import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Fired when a user clicks a suggestion button in the canvas agent chat null state, or selects a suggestion-backed outcome (smart resize or convert to video) in the canvas empty state',
  name: 'clicked_canvas_null_state_suggestion',
  params: [
    {
      description: 'The id of the suggestion that was clicked',
      name: 'suggestion_id',
      required: true,
      type: 'enum',
      values: ['smart_resize', 'run_skill', 'convert_image'],
    },
  ],
};

export default META;
